// node_modules
import React, {use, useContext, useEffect, useRef} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import { format } from "date-fns";
import { useSelector, useDispatch } from "react-redux";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import {ToastContext} from '../../App'
import {checkStationAvailability} from '../../utils/checkStationAvailability'
import getSubdomain from '../../utils/getSubdomain'

// styles
import * as styles from "./StudentHome.module.css";

function StudentHome({ sendViaWS }) {
  const uuid = localStorage.getItem("uuid");
  const showToast = useContext(ToastContext);
  const dispatch = useDispatch();
  const navigate =  useNavigate();

  const openedStations = useSelector((state) => state.stations.openedStations);
  const orders = useSelector((state) => state.orders.orders);
  
  const stationClick = (e, station) => {
    e.preventDefault();
    if(checkStationAvailability(station)) {
      navigate(`/make-order/${station.id}`)
    } else {
      showToast('info', "Station", 'Station not available');
      sendViaWS({
        type: "current-stations",
        data: {
          customer_id: uuid,
          subdomain: getSubdomain(),
          time: format(new Date(), "HH:mm"),
        }
      });
    }
  }

  return (
    <>
      {openedStations?.length === 0 ? (
        <div className={styles.closedPageWrapper}>
          <div className={styles.closedPage}>
            <div className={styles.info}>
              <div className={styles.closedTitle}>
                Dine without the Line is not available for ordering
              </div>
              <div className={styles.closedDescription}>
                Our culinary teams are prepping for your next meal. Please check
                back later. Thank you!
              </div>
              {orders?.length ? (
                <Link to="/order-status" className={styles.orderStatusLink}>
                  <i className="pi pi-clock"></i>
                  <div>my orders</div>
                </Link>
              ) : null}
            </div>
            <div className={styles.image}>
              <DotLottieReact src="/images/plate.lottie" loop autoplay />
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.pageWrapper}>
          <h2 className={styles.title}>Welcome!</h2>

          <div className={styles.mainWrapper}>
            <p className={styles.description}>Pick your meal station 👇</p>

            <div className={styles.cardsWrapper}>
              {openedStations !== null && openedStations?.length ? (
                openedStations.map((station) => (
                  <Link
                    to={`/make-order/${station.id}`}
                    onClick={(e) => stationClick(e, station)}
                    state={{ stationName: station.name }}
                    className={styles.cardWrapper}
                  >
                    <div className={styles.stationCard}>
                      <div
                        style={{
                          backgroundImage: `url(https://dwtl.food/public/images/${station.image_name})`,
                        }}
                        className={styles.image}
                      >
                        <div className={styles.estimatedTime}>
                          {station.statistics.estimated_time
                            ? `~ ${station.statistics.estimated_time}`
                            : `~ 6 min`}
                        </div>
                      </div>
                      <div className={styles.titleWrapper}>
                        <div>{station.name}</div>
                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                <div>Loading...</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default StudentHome;
